export default __webpack_public_path__ + "static/data-vis-status-severity-light-702a8aadb22883ad40fe6904af163be0.png";